export default __webpack_public_path__ + "static/media/check_component.4042db33.svg";